import module from '../module';

module.directive('inputFocus', ['$timeout', function ($timeout) {
    return {
        replace: false,
        scope: {
            inputFocus: '='
        },
        link: function ($scope, element) {
            $scope.inputFocus = function (options) {

                $timeout(() => {
                    element[0].focus();

                    if (options && options.selectAll) {
                        element[0].setSelectionRange(0, 9999);
                    }
                });
            };
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/modules/shared/directives/InputFocusDirective.js